import { TariffGroupAttributeTypeEnum } from '@src/core/buyerApiClient/api';

export type TariffGroupAttributeType = string;

export const LANGUAGE_ATTRIBUTE_TYPE: TariffGroupAttributeType = TariffGroupAttributeTypeEnum.Language;

export type SelectedProductAttribute = {
  type: TariffGroupAttributeType;
  value: string;
};

export type AttributeOption = {
  value: string;
  label: string;
  flagCode?: string;
};

export type AttributeOptionGroup = {
  type: TariffGroupAttributeType;
  options: AttributeOption[];
};

export const isLanguageAttributeType = (type: TariffGroupAttributeType): boolean => type === LANGUAGE_ATTRIBUTE_TYPE;
